import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { toast } from "react-toastify";
import { Btn, H6, P } from "../../../../../AbstractElements";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import { ClipboardOnParagraphTitle, Copy } from "../../../../../Utils/Constants";

export default function ClipboardOnParagraph() {
  const clipboardParagraphText2: string = "On that day, hopes and dreams were crushed. Even though it should have been anticipated, it nonetheless surprised me. The warning indicators have been disregarded in favour of the slim chance that it would actually occur. From a hopeful prospect, it had evolved into an unquestionable conviction that it must be fate. That was up until it wasn't, at which point all of the aspirations and dreams collapsed.";
  const [clipBoardValues, setClipBoardValues] = useState(clipboardParagraphText2);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(clipBoardValues);
      setClipBoardValues(clipBoardValues);
      setTimeout(() => {
        setClipBoardValues(clipBoardValues);
      }, 2000);
    } catch (err) {
      toast.error("Failed to copy text: " + err);
    }
  };
  return (
    <Col sm={12} md={6}>
      <Card>
        <CommonCardHeader title={ClipboardOnParagraphTitle} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="card-description mb-2">{"Copy from paragraph"}</P>
            <H6 className="border rounded f-w-400">
              <CardBody>{clipboardParagraphText2}</CardBody>
            </H6>
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard text-light" color="info" onClick={handleCopy}>
                <i className="fa-solid fa-copy" /> {Copy}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
